import './Assistantsheader.css';

const AssistantsHeader = () => (
  <header className="assistants-hero">
    <div className="lis-container assistants-hero-inner lis-reveal">
      <p className="lis-eyebrow">Comunidad LIS</p>
      <h1>Conoce a nuestros auxiliares</h1>
      <p>Cuando visites los laboratorios encontrarás estudiantes que acompañan el funcionamiento de los espacios y están disponibles para orientarte.</p>
    </div>
  </header>
);

export default AssistantsHeader;
